import { clamp } from '@deltasierra/utilities-math';

/**
 * Clamps an index between 0 and the last index of a list
 * note: this is basically clamp, but it clamps to one less than the max and won't go to -1
 *
 * @param listLength - the list of the length to clamp the index to
 * @param desiredIndex - the index to clamp (will remain the same if there is room)
 * @returns the desired index, clamped between 0 and the last index of the list
 */
export function clampListIndex(listLength: number, desiredIndex: number): number {
    return clamp(0, Math.max(listLength - 1, 0), desiredIndex);
}
